import { render } from "./FooterColumn.vue?vue&type=template&id=71023f5b&scoped=true"
import script from "./FooterColumn.vue?vue&type=script&lang=js"
export * from "./FooterColumn.vue?vue&type=script&lang=js"

import "./FooterColumn.vue?vue&type=style&index=0&id=71023f5b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71023f5b"]])

export default __exports__